import DataTable from 'components/organisms/data-table'
import PropTypes from 'prop-types'
import React from 'react'
import CmsFeaturedSellerTableColumns from '../../molecules/table-column/cms-featured-seller-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  rowButtonProps : PropTypes.shape({
    buttonText    : PropTypes.string,
    buttonColour  : PropTypes.string,
    onButtonClick : PropTypes.func
  }),
  hiddenColumns : PropTypes.arrayOf(PropTypes.string),
  isLoading     : PropTypes.bool
}

const defaultProps = {
  rowButtonProps: {
    buttonText    : '',
    buttonColour  : '',
    onButtonClick : () => {}
  },
  isLoading: false
}

/**
 * Table to display List of CMS Featured Seller
 * @param {Array<Object>} data - array of cms_featured_seller objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */

const CmsFeaturedSellerTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  const { buttonText, buttonColour, onButtonClick } = rowButtonProps

  const columns = CmsFeaturedSellerTableColumns({
    buttonText,
    buttonColour,
    onButtonClick
  })

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      hiddenColumns={ hiddenColumns }
      isLoading={ isLoading }
    />
  )
}

CmsFeaturedSellerTable.propTypes    = propTypes
CmsFeaturedSellerTable.defaultProps = defaultProps

export default CmsFeaturedSellerTable
